import { useState, useEffect } from "react";
import { useSelectedAgainstAJobQuery } from "../graphql/generated/graphql";

const useSelectedAgainstAJob = (jobId: any) => {
  const [matchs, setMatchs]: any = useState(null);
  const { data, loading, error, refetch } = useSelectedAgainstAJobQuery({
    variables: {
      jobId: jobId,
    },
    fetchPolicy: "network-only",
  });
  const loadMatches = () => {
    if (!loading && data) {
      // console.log(data.selectedAgainstAJob);
      setMatchs(data.selectedAgainstAJob);
    }
  };

  useEffect(() => {
    loadMatches();
  }, [data]);

  return { matchs, refetch };
};

export default useSelectedAgainstAJob;
